import { makeAutoObservable, runInAction } from 'mobx';
import { toast } from 'react-toastify';
import agent from '../api/agent';
import { Vault } from '../models/vault';
import { store } from './store';
import { vaultListType } from '../api/types';

export default class VaultStore {
  vaultRegistry = new Map<string, Vault>();
  selectedVault: Vault | undefined = undefined;
  loadingInitial = false;
  loading = false;
  vaultList: vaultListType[] = [];
  HFCvaultList: string[] = [];
  rackList: string[] = [];
  roomList:string[] =[]
  aisleList:string[]=[]
  HFCShelfList:string[]=[]
  shelfList: string[] = [];
  pigeonList: { key: string; text: string; value: string }[] = [];

  constructor() {
    makeAutoObservable(this);
  }
  get vaultitemsByDate() {
    return Array.from(this.vaultRegistry.values());
  }
  setLoadingInitial = (state: boolean) => {
    this.loadingInitial = state;
  };

  private setVault = (Vault: Vault) => {
    this.vaultRegistry.set(Vault.id, Vault);
  };

  // private getVault = (id: string) => {
  //   return this.vaultRegistry.get(id);
  // };

  loadVaults = async () => {
    this.loadingInitial = true;
    try {
      const vaultdetail = await agent.Vaults.list();
      // console.log(recievingdelivery);
      vaultdetail.forEach((vaultdetail) => {
        runInAction(() => {
          this.setVault(vaultdetail);
        });
      });
      this.setLoadingInitial(false);
    } catch (error) {
      runInAction(() => {
        console.log(error);
        this.setLoadingInitial(false);
      });
    }
  };

  loadVault = async (id: string) => {
    this.loadingInitial = true;
    try {
      const vaultdetail = await agent.Vaults.details(id);
      this.setVault(vaultdetail);
      runInAction(() => {
        this.selectedVault = vaultdetail;
      });
      this.setLoadingInitial(false);
      return vaultdetail;
    } catch (error) {
      console.log(error);
      this.setLoadingInitial(false);
    }
  };

  createVault = async (vault: Vault) => {
    this.loading = true;
    try {
      await agent.Vaults.create(vault);
      runInAction(() => {
        this.vaultRegistry.set(vault.id, vault);
        this.selectedVault = vault;
        //this.editMode = false;
        this.loading = false;
      });
      store.userStore.user?.customerName === 'LVP CMS - AM'
        ? toast.success('Room Record Created Successfully ')
        : toast.success('Vault Record Created Successfully ');
    } catch (error) {
      console.log(error);
      runInAction(() => {
        this.loading = false;
      });
    }
  };
  updateVault = async (vault: Vault) => {
    this.loading = true;

    try {
      await agent.Vaults.update(vault);
      runInAction(() => {
        this.vaultRegistry.set(vault.id, vault);
        this.selectedVault = vault;
        this.loading = false;
      });
      store.userStore.user?.customerName === 'LVP CMS - AM'
        ? toast.success('Room Record Updated Succesfully')
        : toast.success('Vault Record Updated Succesfully');
    } catch (error) {
      console.log(error);
      runInAction(() => {
        this.loading = false;
      });
    }
  };
  deleteVault = async (vault: Vault) => {
    try {
      await agent.Vaults.delete(vault);
      runInAction(() => {
        this.vaultRegistry.delete(vault.id);
      });
      toast.success('Vault Deleted Succesfully.');
    } catch (error) {
      runInAction(() => {
        console.log(error);
      });
    }
  };

  getVaultList = async () => {
    try {
      const response = await agent.Vaults.vaultList();
      runInAction(() => {
        if (response.data.length > 0) {
          this.vaultList = response.data;
        }
      });
    } catch (error) {
      toast.error('Failed to fetch Vault List');
      console.log('API Failed: ', error);
    }
  };

  getRackList = async (params: { vaultId: string }) => {
    try {
      const response = await agent.Vaults.rackList(params);
      runInAction(() => {
        this.rackList = response.data;
      });
    } catch (error) {
      toast.error('Failed to fetch Rack List');
      console.log('API Failed: ', error);
    }
  };


getHFCVaultList = async () => {
  try {
      const response = await agent.HFC.HFCVault();
      runInAction(() => {
          this.HFCvaultList = response.data.map((vault: any) => ({
              key: vault.id,
              value: vault.vaultName,
              text: vault.vaultName,
          }));
      });
  } catch (error) {
      toast.error('Failed to fetch Vault List');
      console.log('API Failed: ', error);
  }
};


// getRoomList = async (vaultId: string) => {
//   try {
//       const response = await agent.HFC.HFCRoom(vaultId);
//       const rooms = response.data.map((room: string, index: number) => ({
//           key: index,
//           value: room,
//           text: room,
//       }));
//       runInAction(() => {
//           this.roomList = rooms;
//       });
//   } catch (error) {
//       toast.error('Failed to fetch Room List');
//       console.log('API Failed: ', error);
//   }
// };
// getAisleList = async (vaultId: string, roomName: string) => {
//   try {
//       const response = await agent.HFC.HFCAisle(vaultId, roomName);
//       const aisle = response.data.map((aisle: any, index: number) => ({
//         key: index,
//         value: aisle, // Adjust this based on the response data
//         text: aisle, // Adjust this based on the response data
//     }));
//       runInAction(() => {
//           this.aisleList = aisle;
//       });
//   } catch (error) {
//       toast.error('Failed to fetch Aisle List');
//       console.log('API Failed: ', error);
//   }
// };

// getHFCShelfList = async (vaultId: string, roomName: string, aisleNo: string) => {
//   try {
//       const response = await agent.HFC.HFCShelf(vaultId, roomName, aisleNo);
//       const shelf = response.data.map((shelf: any, index: number) => ({
//         key: index,
//         value: shelf, // Adjust this based on the response data
//         text: shelf, // Adjust this based on the response data
//     }));
//       runInAction(() => {
//           this.HFCShelfList = shelf;
//       });
//   } catch (error) {
//       toast.error('Failed to fetch Shelf List');
//       console.log('API Failed: ', error);
//   }
// };


  getShelfList = async (params: { vaultId: string; rackNo: string }) => {
    try {
      const response = await agent.Vaults.shelfList(params);
      runInAction(() => {
        if (response.data.length > 0) {
          this.shelfList = response.data;
        }
      });
    } catch (error) {
      toast.error('Failed to fetch Shelf List');
      console.log('API Failed: ', error);
    }
  };

  getPigeonList = () => {
    this.pigeonList = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10']?.map(
      (r: string) => {
        return {
          key: r,
          text: r,
          value: r,
        };
      },
    );
  };
}
